// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e89c7e83","455":"8a47dc7a","977":"afd22c5d"}[chunkId] + ".chunk.js";
};